import { isLowerEnvironment } from './environment';

const pushDataLayer = (dataObject) => {
  if (window.dataLayer) {
    window.dataLayer.push(dataObject);
  }
};

const clientReportingScript = (() =>
  isLowerEnvironment
    ? 'https://asset-qa2.chase.com/web/library/digddsautomation/reportingjs/Reporting.js'
    : 'https://asset.chase.com/web/library/digddsautomation/reportingjs/Reporting.js')();

export { clientReportingScript, pushDataLayer };
